import instance from '@/service/instance';
import { AxiosPromise } from 'axios';
import { Category } from '@/helpers/types'

const resource: string = '/category';

export default {
  list(token: string): AxiosPromise<Category[]> {
    return instance(`${resource}/`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }
};
